import { deleteField } from 'firebase/firestore';

export const removeUndefinedFields = (
  obj: { [k: string]: any },
  options?: { undefinedTo?: 'null' | 'deleteField' },
) => {
  const { undefinedTo } = options || {};

  const newObj = { ...obj };

  for (const key in newObj) {
    if (newObj[key] === undefined) {
      if (undefinedTo === 'null') {
        newObj[key] = null;
      } else if (undefinedTo === 'deleteField') {
        newObj[key] = deleteField();
      } else {
        delete newObj[key];
      }
    }
  }

  return newObj;
};

/** Firestore rejects the write: this client runs without `ignoreUndefinedProperties`. */
export const removeUndefinedFieldsDeep = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value
      .filter((entry) => entry !== undefined)
      .map(removeUndefinedFieldsDeep) as T;
  }
  if (value && typeof value === 'object' && value.constructor === Object) {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([, entry]) => entry !== undefined)
        .map(([key, entry]) => [key, removeUndefinedFieldsDeep(entry)]),
    ) as T;
  }
  return value;
};

const WRITE_CONFLICT_CODES = new Set(['aborted', 'failed-precondition']);

export const isFirestoreWriteConflict = (error: unknown): boolean =>
  WRITE_CONFLICT_CODES.has((error as { code?: string } | null)?.code ?? '');
